/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ParkingAvailable } from './ParkingAvailable';
import {
    ParkingAvailableFromJSON,
    ParkingAvailableFromJSONTyped,
    ParkingAvailableToJSON,
    ParkingAvailableToJSONTyped,
} from './ParkingAvailable';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
    AddressToJSONTyped,
} from './Address';
import type { PhoneNumber } from './PhoneNumber';
import {
    PhoneNumberFromJSON,
    PhoneNumberFromJSONTyped,
    PhoneNumberToJSON,
    PhoneNumberToJSONTyped,
} from './PhoneNumber';
import type { TransportStop } from './TransportStop';
import {
    TransportStopFromJSON,
    TransportStopFromJSONTyped,
    TransportStopToJSON,
    TransportStopToJSONTyped,
} from './TransportStop';

/**
 * information of a health pro
 * @export
 * @interface HealthPro
 */
export interface HealthPro {
    /**
     * unique identifier of the health pro
     * @type {string}
     * @memberof HealthPro
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof HealthPro
     */
    firstname?: string;
    /**
     * 
     * @type {string}
     * @memberof HealthPro
     */
    lastname?: string;
    /**
     * 
     * @type {string}
     * @memberof HealthPro
     */
    title?: string;
    /**
     * 
     * @type {Address}
     * @memberof HealthPro
     */
    address?: Address;
    /**
     * 
     * @type {PhoneNumber}
     * @memberof HealthPro
     */
    phoneNumber?: PhoneNumber;
    /**
     * 
     * @type {PhoneNumber}
     * @memberof HealthPro
     */
    faxNumber?: PhoneNumber;
    /**
     * mail address of the doctor
     * @type {string}
     * @memberof HealthPro
     */
    mail?: string;
    /**
     * description of the diplomas of the health pro
     * @type {string}
     * @memberof HealthPro
     */
    diploma?: string;
    /**
     * presentation of the health pro
     * @type {string}
     * @memberof HealthPro
     */
    presentation?: string;
    /**
     * description of the fees charged by the health pro for the different consultations
     * @type {string}
     * @memberof HealthPro
     */
    fees?: string;
    /**
     * description of the means of payment accepted by the health pro
     * @type {string}
     * @memberof HealthPro
     */
    meansOfPayment?: string;
    /**
     * the file of the avatar of the health pro
     * @type {Blob}
     * @memberof HealthPro
     */
    avatar?: Blob;
    /**
     * true if the teleconsultation can be possible, false otherwise
     * @type {boolean}
     * @memberof HealthPro
     */
    isTeleconsultationAvailable?: boolean;
    /**
     * true if the doctor is open to new patients, false otherwise
     * @type {boolean}
     * @memberof HealthPro
     */
    openToNewPatients?: boolean;
    /**
     * 
     * @type {string}
     * @memberof HealthPro
     */
    speciality?: string;
    /**
     * 
     * @type {Array<ParkingAvailable>}
     * @memberof HealthPro
     */
    parking?: Array<ParkingAvailable>;
    /**
     * 
     * @type {Array<TransportStop>}
     * @memberof HealthPro
     */
    publicTransport?: Array<TransportStop>;
    /**
     * First line of the health pro's title or specialty (e.g., professional qualification).
     * @type {string}
     * @memberof HealthPro
     */
    titleLine1?: string;
    /**
     * Second line of the health pro's title or additional information (optional).
     * @type {string}
     * @memberof HealthPro
     */
    titleLine2?: string;
    /**
     * Complementary info describe by the health pro
     * @type {string}
     * @memberof HealthPro
     */
    complementaryInformation?: string;
    /**
     * Schedule describe by the health pro
     * @type {string}
     * @memberof HealthPro
     */
    weekSchedule?: string;
    /**
     * Institute name
     * @type {string}
     * @memberof HealthPro
     */
    instituteName?: string;
    /**
     * 
     * @type {string}
     * @memberof HealthPro
     */
    appointmentGeneralMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof HealthPro
     */
    generalMessage?: string;
}

/**
 * Check if a given object implements the HealthPro interface.
 */
export function instanceOfHealthPro(value: object): value is HealthPro {
    return true;
}

export function HealthProFromJSON(json: any): HealthPro {
    return HealthProFromJSONTyped(json, false);
}

export function HealthProFromJSONTyped(json: any, ignoreDiscriminator: boolean): HealthPro {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'firstname': json['firstname'] == null ? undefined : json['firstname'],
        'lastname': json['lastname'] == null ? undefined : json['lastname'],
        'title': json['title'] == null ? undefined : json['title'],
        'address': json['address'] == null ? undefined : AddressFromJSON(json['address']),
        'phoneNumber': json['phoneNumber'] == null ? undefined : PhoneNumberFromJSON(json['phoneNumber']),
        'faxNumber': json['faxNumber'] == null ? undefined : PhoneNumberFromJSON(json['faxNumber']),
        'mail': json['mail'] == null ? undefined : json['mail'],
        'diploma': json['diploma'] == null ? undefined : json['diploma'],
        'presentation': json['presentation'] == null ? undefined : json['presentation'],
        'fees': json['fees'] == null ? undefined : json['fees'],
        'meansOfPayment': json['meansOfPayment'] == null ? undefined : json['meansOfPayment'],
        'avatar': json['avatar'] == null ? undefined : json['avatar'],
        'isTeleconsultationAvailable': json['isTeleconsultationAvailable'] == null ? undefined : json['isTeleconsultationAvailable'],
        'openToNewPatients': json['openToNewPatients'] == null ? undefined : json['openToNewPatients'],
        'speciality': json['speciality'] == null ? undefined : json['speciality'],
        'parking': json['parking'] == null ? undefined : ((json['parking'] as Array<any>).map(ParkingAvailableFromJSON)),
        'publicTransport': json['publicTransport'] == null ? undefined : ((json['publicTransport'] as Array<any>).map(TransportStopFromJSON)),
        'titleLine1': json['titleLine1'] == null ? undefined : json['titleLine1'],
        'titleLine2': json['titleLine2'] == null ? undefined : json['titleLine2'],
        'complementaryInformation': json['complementaryInformation'] == null ? undefined : json['complementaryInformation'],
        'weekSchedule': json['weekSchedule'] == null ? undefined : json['weekSchedule'],
        'instituteName': json['instituteName'] == null ? undefined : json['instituteName'],
        'appointmentGeneralMessage': json['appointmentGeneralMessage'] == null ? undefined : json['appointmentGeneralMessage'],
        'generalMessage': json['generalMessage'] == null ? undefined : json['generalMessage'],
    };
}

export function HealthProToJSON(json: any): HealthPro {
    return HealthProToJSONTyped(json, false);
}

export function HealthProToJSONTyped(value?: HealthPro | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'firstname': value['firstname'],
        'lastname': value['lastname'],
        'title': value['title'],
        'address': AddressToJSON(value['address']),
        'phoneNumber': PhoneNumberToJSON(value['phoneNumber']),
        'faxNumber': PhoneNumberToJSON(value['faxNumber']),
        'mail': value['mail'],
        'diploma': value['diploma'],
        'presentation': value['presentation'],
        'fees': value['fees'],
        'meansOfPayment': value['meansOfPayment'],
        'avatar': value['avatar'],
        'isTeleconsultationAvailable': value['isTeleconsultationAvailable'],
        'openToNewPatients': value['openToNewPatients'],
        'speciality': value['speciality'],
        'parking': value['parking'] == null ? undefined : ((value['parking'] as Array<any>).map(ParkingAvailableToJSON)),
        'publicTransport': value['publicTransport'] == null ? undefined : ((value['publicTransport'] as Array<any>).map(TransportStopToJSON)),
        'titleLine1': value['titleLine1'],
        'titleLine2': value['titleLine2'],
        'complementaryInformation': value['complementaryInformation'],
        'weekSchedule': value['weekSchedule'],
        'instituteName': value['instituteName'],
        'appointmentGeneralMessage': value['appointmentGeneralMessage'],
        'generalMessage': value['generalMessage'],
    };
}

